export default __webpack_public_path__ + "static/media/IMG_2257-4_x3.bd670de3.jpg";